import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import CheckBoxSingleBool from '@lib/components/CheckBoxSingleBool/CheckBoxSingleBool';
import { isWidgetSelected } from './validationHelpers';

/**
 * Returns fields for Active Interventions widget
 */
export default function getActiveInterventionsFields(
  t: TFunction,
): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.ActiveInterventionsInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-active-interventions-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.ActiveInterventions),
    },
    {
      name: WidgetFieldNames.ShowOnlyMyInterventions,
      label: t('show-only-my-interventions'),
      element: CheckBoxSingleBool,
      componentProps: {
        options: [{ label: 'checked', value: 'checked' }],
      },
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.ActiveInterventions),
    },
  ];
}
